// Imports
import React from "react"
import { NavLink, useLocation } from "react-router-dom"
import { Header } from "fajny-react"
import { v4 as uuid } from "uuid"
import styled from "styled-components"

import DefaultLayout from "./DefaultLayout"
import Footer from "./Footer"

import nav from "../data/nav"

const StyledHeader = styled(Header)`
    z-index: ${({ $behind }) => $behind && 1};
`

const BaseLayout = ({ title, description, category, keywords, children }) => {
    const location = useLocation().pathname

    return (
        <DefaultLayout title={title} description={description} category={category} keywords={keywords}>
            <StyledHeader
                headerStyle="plain"
                color="primary"
                logoImg="/images/logo-fajny-css-white.svg"
                logoAlt="Logo Fajny CSS"
                position={location === "/" ? "absolute" : "relative"}
                $behind={location === "/components/modal" && true}
            >
                {nav.map(item => (
                    <NavLink to={item.to} key={uuid()}>
                        {item.text}
                    </NavLink>
                ))}
            </StyledHeader>

            {children}

            <Footer />
        </DefaultLayout>
    )
}

export default BaseLayout
